import React from 'react';
import { Invoice, PaymentCurrency } from '../../interfaces/screens/billing';
import CurrencyDisplay from '../CurrencyDisplay';

interface ExportInvoiceModalProps {
  invoice: Invoice;
  onClose: () => void;
  onExport: () => void;
}

const ExportInvoiceModal: React.FC<ExportInvoiceModalProps> = ({ invoice, onClose, onExport }) => {
  return (
    <div className="flex flex-col gap-6 p-4">
      <div>
        <p className="text-gray-600 dark:text-gray-400">
          Export invoice <strong>{invoice.invoice_number}</strong> to PDF.
        </p>
        <div className="mt-4 p-3 bg-gray-50 dark:bg-gray-800 rounded-md">
          <p className="text-sm text-gray-600 dark:text-gray-400">
            <strong>Invoice Details:</strong>
          </p>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            Total:{" "}
            <CurrencyDisplay
              amount={invoice.total_amount}
              currency={
                (invoice.line_items[0]?.currency as PaymentCurrency) || "USD"
              }
            />
          </p>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            Balance:{" "}
            <CurrencyDisplay
              amount={invoice.balance_due}
              currency={
                (invoice.line_items[0]?.currency as PaymentCurrency) || "USD"
              }
            />
          </p>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            Status: {invoice.status}
          </p>
        </div>
      </div>

      <div className="flex justify-end gap-3">
        <button
          onClick={onClose}
          className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-800 rounded-md hover:bg-gray-200 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 dark:focus:ring-gray-400 transition-colors duration-200"
        >
          Cancel
        </button>
        <button
          onClick={onExport}
          className="px-4 py-2 text-sm font-medium text-white bg-primary rounded-md hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-colors duration-200"
        >
          Export
        </button>
      </div>
    </div>
  );
};

export default ExportInvoiceModal; 